/*
 * Copyright (c) 2022. Haodong JU
 */

import GlobalSettings from '@/GlobalSettings'
import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'
import ConsumeType from '../buffet/ConsumeType'
import CategoryType from '../dish/CategoryType'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start',
    },
    formConfig: {
      requiredNew: false,
    },
  },
  consumeTypeId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      requiredEdit: false,
      type: {
        selectItems: ConsumeType.getList,
      },
    },
  },
  dishesCategoryTypeId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      requiredEdit: false,
      type: {
        selectItems: CategoryType.getList,
      },
    },
  },
  taxRateValue: {},
}
const config = {
  edit: function (item) {
    return hillo.postWithUploadFile('TaxRate.php?op=update', item, {
      showLoading: true,
    })
  },
  load: async function (filter) {
    return (await hillo.get('TaxRate.php?', {
      op: 'getList',
      lang: GlobalSettings.getLang(),
      ...filter,
    })).content
  },
}

export default IKDataEntity.ModelFactory(entity, config)
